import React, { CSSProperties, FunctionComponent, useEffect, useRef } from 'react';

interface Props {
    outsideClickHandler: any;
    styles?: CSSProperties;
}

export const OutsideClick: FunctionComponent<Props> = ({ outsideClickHandler, styles, children }): JSX.Element => {
    const outsideContainerRef = useRef(null);

    useEffect((): any => {
        document.addEventListener('mousedown', handleOutsideClick);
        return (): void => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handleOutsideClick = (event: any): void => {
        const currentRef: any = outsideContainerRef?.current;

        if (currentRef !== null && !currentRef.contains(event.target)) {
            outsideClickHandler(event);
        }
    };

    return (
        <div className="r4e-outside-click" style={styles} ref={outsideContainerRef}>
            {children}
        </div>
    );
};
